/* Site-Specific JavaScript */

(function () {
    var skipLinks = document.querySelectorAll('#skipLinks a[href^="#"], #skipLinksIntegratedMobile a[href^="#"]');
    skipLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (!target) {
                return;
            }
            e.preventDefault();
            if (!target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', '-1');
            }
            target.focus();
            target.scrollIntoView();
        });
    });
})();

jq(function () {
    jq('.slider-wrapper--multi').each(function () {
        jq(this).slick({
            dots: true,
            fade: true,
            arrows: false,
            adaptiveHeight: true,
            accessibility: true
        });
    });
});

jq(function () {
    if (typeof AOS === 'undefined') {
        return;
    }
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
        // AOS never runs, but the AOS stylesheet still hides any element that carries a
        // server-rendered data-aos attribute (hero title/copy, news row columns). Drop the
        // attributes so that content is visible without animation.
        jq('[data-aos]').removeAttr('data-aos').removeAttr('data-aos-delay');
        return;
    }
    jq('.module, .page-banner').each(function () {
        var container = jq(this).find('.container').first();
        if (container.length && !container.attr('data-aos')) {
            container.attr('data-aos', 'fade-in');
        }
    });
    AOS.init({
        once: true,
        duration: 600,
        offset: 80,
        disable: function () {
            return window.innerWidth < 768;
        }
    });
});

// Header on-scroll bg/logo swap (matches production behavior)
jq(function () {
    var header = jq('#site-header');
    if (!header.length) {
        return;
    }
    var threshold = 10;
    function checkScroll() {
        if (jq(window).scrollTop() > threshold) {
            header.addClass('header-scrolled');
        } else {
            header.removeClass('header-scrolled');
        }
    }
    jq(window).on('scroll', checkScroll);
    checkScroll();
});

jq(function () {
    var $filters = jq('form.redirect-select select');
    if (!$filters.length) {
        return;
    }
    $filters.on('change', function () {
        var $form = jq(this).closest('form');
        var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        var query = '';
        $form.find('select').each(function () {
            var value = jq(this).val();
            if (value != -1 && value !== 'all') {
                query += (query.length ? '&' : '?') + jq(this).attr('name') + '=' + encodeURIComponent(value);
            }
        });
        if (window.location.href !== url + query) {
            window.location.href = url + query;
        }
    });
});


const initQuickLinksCurrentPage = () => {
    const pathname = window.location.pathname;
    jq('.module-quick-links a').each(function () {
        if (this.getAttribute('href') === pathname) {
            this.parentElement.classList.add('active');
            this.setAttribute('aria-current', 'page');
        }
    });
};

jq(document).ready(function() {
    initQuickLinksCurrentPage();
})
jq(function () {
    var markKlaroLinks = function () {
        jq('.klaro a[href="#"]').not('[role]').attr('role', 'button');
        // Klaro gives the cookie notice aria-labelledby="id-cookie-title" but never renders that title
        // element, so the dialog has no accessible name (axe aria-dialog-name). Name it directly.
        jq('#klaro-cookie-notice[role="dialog"]').not('[aria-label]').each(function () {
            var labelledBy = this.getAttribute('aria-labelledby');
            if (!labelledBy || !document.getElementById(labelledBy)) {
                this.removeAttribute('aria-labelledby');
                this.setAttribute('aria-label', 'Cookie consent');
            }
        });
    };
    markKlaroLinks();
    if (window.MutationObserver) {
        new MutationObserver(markKlaroLinks).observe(document.body, { childList: true, subtree: true });
    }
});

// SEC Filings: the Company selector switches between the per-company filing pages (production behaviour)
jq(function () {
    jq('#company-picker').on('change', function () {
        var url = jq(this).val();
        if (url && url !== window.location.pathname) {
            window.location = url;
        }
    });
});

// Escape handling for navigation submenus (QC 29056225) now lives in initDisclosureNav()
// in scripts.js: the disclosure buttons own open/close, Esc closes the open submenu and
// returns focus to its toggle, and the off-canvas panel closes through its trigger.

// QMod tabs (Stock Summary): QuoteMedia initialises the tools inside the hidden tab panes and marks
// those panes aria-hidden="true" with their controls at tabindex="-1", but never undoes it when the
// pane is shown, so the Historical Data controls were unreachable by keyboard and screen readers
// (found while fixing QC 29056210). Restore the shown pane once it is visible (and again after a data
// reload, which re-renders the controls); the hidden panes stay out of the tab order through the
// .tab-pane__quote:not(.active) visibility rule in _qmod.scss.
jq(function () {
    var restoreQmodPane = function (pane) {
        if (!pane || !pane.classList.contains('active')) {
            return;
        }
        pane.removeAttribute('aria-hidden');
        jq(pane).find('.qmod-btn[tabindex="-1"], .qmod-no-btn[tabindex="-1"]').each(function () {
            if (!jq(this).closest('.duet-date__dialog').length) {
                this.removeAttribute('tabindex');
            }
        });
    };
    var scheduleRestore = function (pane) {
        [0, 400, 800, 1600, 2500].forEach(function (delay) {
            window.setTimeout(function () { restoreQmodPane(pane); }, delay);
        });
    };
    jq(document).on('shown.bs.tab', '[data-bs-toggle="tab"]', function (event) {
        var pane = document.querySelector(event.target.getAttribute('href') || event.target.getAttribute('data-bs-target') || '');
        if (pane && pane.classList.contains('tab-pane__quote')) {
            scheduleRestore(pane);
        }
    });
    jq(document).on('click', '.tab-pane__quote .qmod-btn-go', function () {
        scheduleRestore(jq(this).closest('.tab-pane__quote')[0]);
    });
});
